import { createContext, useContext } from "react";

const fallback = {
  enabled: false,
  run: async ({ task }) => task(),
  showAnswer: () => {},
};

export const LongActionContext = createContext(fallback);
export const useLongAction = () => useContext(LongActionContext);
export default useLongAction;

export const actionFailure = (error, format) => {
  if (["ECONNABORTED", "ETIMEDOUT"].includes(error?.code)) return {
    status: "timeout", label: "The server has not answered",
    message: "The request timed out. The server may still finish. Reload to check the result.",
    onReload: () => window.location.reload(),
  };
  const answer = typeof format === "function" ? format(error) : format;
  return answer ? {
    label: "Unable to complete the action", status: "error",
    ...(typeof answer === "string" ? { message: answer } : answer),
  } : null;
};
